import { useLazyQuery } from '@apollo/client';
import { useMemo } from 'react';

import {
  GetSalesOrdersByBillingCyclePrediction,
  GetSalesOrdersByBillingCyclePredictionVariables,
} from  '@/graphql/contracts/_generated_/getSalesOrdersByBillingCyclePrediction.query';
import GetSalesOrdersByBillingCyclePredictionQuery 
  from '@/graphql/contracts/getSalesOrdersByBillingCyclePrediction.query.gql';
import { apolloClientContracts } from '@/apollo/clients/contracts.apollo';
import { notificationService } from '@/services/notification/notification.client';

export function useGetSalesOrdersByBillingCyclePrediction() {

  const [_getSalesOrdersByBillingCyclePrediction, { data, loading }] = useLazyQuery<
  GetSalesOrdersByBillingCyclePrediction,
  GetSalesOrdersByBillingCyclePredictionVariables
  >(GetSalesOrdersByBillingCyclePredictionQuery, {
    client: apolloClientContracts,
    onError: (err) => {
      notificationService.open({
        title: 'Error',
        text: err.message,
        type: 'danger',
      });
    },
  });

  const getSalesOrdersByBillingCyclePrediction = (startFrom: Date, endBy: Date) => {
    _getSalesOrdersByBillingCyclePrediction({
      variables: {
        startFrom,
        endBy,
      },
    });
  };

  return useMemo(
    () => ({
      getSalesOrdersByBillingCyclePrediction,
      isLoadingBillingCyclePrediction: loading,
      salesOrdersByBillingCyclePrediction: data?.salesOrdersByBillingCyclePrediction?.quantities,
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [loading, data],
  );
}
